import { Action, createReducer, on } from '@ngrx/store';
import { fetchStampingpartnersListData, fetchStampingpartnersListSuccess, fetchStampingpartnersListFailure, blockStampingpartner, blockStampingpartnerSuccess, blockStampingpartnerFailure, addStampingpartner, addStampingpartnerSuccess, addStampingpartnerFailure, editStampingpartner, editStampingpartnerSuccess, editStampingpartnerFailure } from "./stampingpartner.actions";
import { StampingPartnersModel } from '../../core/models/stampingpartner.models';

export interface StampingpartnerState {
    partnerdata: StampingPartnersModel | null;
    loading: boolean;
    error: any;
}

export const initialState: StampingpartnerState = {
    partnerdata: null,
    loading: false,
    error: null,
};

export const StampingpartnerReducer = createReducer(
    initialState,

    // Stampingpartner
    on(fetchStampingpartnersListData, (state) => {
        return { ...state, loading: true, error: null };
    }),
    on(fetchStampingpartnersListSuccess, (state, { partnerdata }) => {
        return { ...state, partnerdata, loading: false };
    }),
    on(fetchStampingpartnersListFailure, (state, { error }) => {
        return { ...state, error, loading: false };
    }),
    on(blockStampingpartner, (state) => ({ ...state, loading: true, error: null })),
    on(blockStampingpartnerSuccess, (state, { userguid }) => {
        return { ...state, loading: false, error: null };
      }),
    on(blockStampingpartnerFailure, (state, { error }) => ({ ...state, error, loading: false })),
    on(addStampingpartner, (state) => ({ ...state, loading: true, error: null })),
    on(addStampingpartnerSuccess, (state, { partner }) => {
        return { ...state, loading: false, error: null };
      }),
    on(addStampingpartnerFailure, (state, { error }) => ({ ...state, error, loading: false })),
    on(editStampingpartner, (state) => ({ ...state, loading: true, error: null })),
    on(editStampingpartnerSuccess, (state, { partner }) => {
        return { ...state, partner: partner, loading: false, error: null };
      }),
    on(editStampingpartnerFailure, (state, { error }) => ({ ...state, error, loading: false })),
);

// Selector
export function reducer(state: StampingpartnerState | undefined, action: Action) {
    return StampingpartnerReducer(state, action);
}
